import React from 'react';
import styled, { css } from 'styled-components';
import __ from '../utils/translator';
import { default as BellIcon} from '../icons/NotificationBell';
import thronPublicThumbnail from '../utils/thronPublicThumbnail';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import remToPixels from '../utils/remToPixels';
import JwtStore from '../flux/JwtStore';

function getAssetSrc({ contentId, pKey }) {
  return thronThumbnailResize(thronPublicThumbnail(contentId, pKey), { height: remToPixels(11.75)});
}

export default function NewsList({
  items,
  onMediaClick,
}) {
  const lastLoginAt = JwtStore.getLastLoginAt();

  return (
    <React.Fragment>
      <NewsContainer>
        <NewsContainerInner>
          <div style={{paddingLeft: '3.25rem', paddingTop: '0.87rem', borderLeft: '2px solid rgb(222,222,222)'}}>
          <div>
            <NewsListTitle>
              <NotificationIcon />
              {__('Notifications')}
            </NewsListTitle>
            <div style={{margin: '0', padding: '0'}}>
              <h2 style={{ marginTop: 0, marginBottom: 0, textTransform: 'uppercase'}}>
                {__('News feed')}
              </h2>
            </div>
          </div>
            {items.length === 0 &&
            <div style={{margin: '2rem 0rem 2rem 0rem'}}>{__('No news available')}</div>
            }
          {items.map(n => (
            <NewsItemContainer key={n.id} isNew={lastLoginAt < n.started_at}>
              <NewsItem
                        content={n.content}
                        category={n.category}
                        title={n.title}
                        assets={n.assets}
                        isNew={lastLoginAt < n.started_at} />
              <NewsMediaContainer>
                <NewsMediaContainerInner>
                {n.assets.map(asset => (
                  <NewsMedia onClick={() => onMediaClick(asset)} key={asset.id}>
                    <NewsAsset src={getAssetSrc(asset)}/>
                    {asset.type && asset.type.toLowerCase() === 'video' && (
                      <ImageOverlayIcon>
                        <svg viewBox="0 0 26 26" style={{ width: '3.25rem', height: '3.25rem', }}>
                          <g fill="none" fillRule="evenodd">
                            <path stroke="#979797" strokeWidth={.5} fillOpacity={.83} fill="#272727" d="M.25.25h25.5v25.5H.25z" />
                            <path fill="#FFF" d="M16.073 12.934L10.4 17.046V8.82z" />
                          </g>
                        </svg>
                      </ImageOverlayIcon>
                    )}
                  </NewsMedia>
                ))}
                </NewsMediaContainerInner>
              </NewsMediaContainer>
            </NewsItemContainer>
          ))}
          </div>
        </NewsContainerInner>
      </NewsContainer>
    </React.Fragment>
  )
}


const NewsContainer = styled.div``;

const NewsContainerInner = styled.div`
  max-width: 60.5rem;
  margin-right: auto;
  margin-left: auto;
  padding: 0 6.5rem 2.5rem 3.125rem;
`;

const NewsListTitle = styled.h3`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0;
`;

const NotificationIcon = styled(BellIcon)`
    position: absolute;
    left: -3.34rem;
    transform: translateX(-50%);
    width: 1.75rem;
    height: 1.75rem;
    background-color: rgb(245,245,245);
    color: #666;
`;


const ImageOverlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 0;
  cursor: pointer;
`;

const NewsItemContainer = styled.div`
    position:relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 1.5rem 0;

    &:before {
    content: '';
    display: block;
    position: absolute;
    background-color: #CCCCCC;
    ${props => props.isNew && css `
        background-color: #78012B;
    `};
    left: -3.76rem;
    top: 1rem;
    bottom: 0;
    width: 0.92rem;
    height: 0.92rem;
  }
`;

const NewsContent = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  color: #3e3e3e;
  white-space: pre-wrap;
  font-size: .75rem;
  line-height: 1rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${({ expanded }) => !expanded && css`
    -webkit-line-clamp: 2;
  `
  };
`;

const NewsItem = ({ content, title, assets, expanded, isNew, category, ...props }) => {

  return (
    <div {...props} style={{
      flex: assets.length > 0 ? '0 0 65%' : '0 0 100%',
    }}>
      <div style={{color: isNew ? '#78012B' : '#000'}}>
        <h3 style={{
          display: 'inline-block',
          marginTop: '.5rem',
          marginBottom: '1.31rem',
          color: isNew ? '#78012B' : '#000',
          textDecoration: 'underline',
          textTransform: 'uppercase',
          fontWeight: 'bold',
        }}>{title}
        </h3>
        {assets.length > 0 &&
        <span>&nbsp;({ __(':length media', { length: assets.length }) })</span>
        }
      </div>
      <div>
        <NewsContent expanded={expanded}>
          {content}
        </NewsContent>
        {category !== null && <div style={{ marginTop: '1.5rem', fontStyle: 'italic', fontSize: '.75rem', color: '#323232', }}>{category}</div>}
      </div>
    </div>
  )
};


const NewsMediaContainer = styled.div`
  overflow-x: hidden;
  padding-left: 2rem;
  -webkit-overflow-scrolling: touch;
`;

const NewsMediaContainerInner = styled.div`
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
`;

const NewsMedia = (props) => {
  return (
    <div {...props} style={{
      position: 'relative',
      display: 'inline-block',
      padding: '.75rem'
    }}>
    </div>
  )
};

const NewsAsset = styled.img`
    height: 10rem;
    box-shadow: rgba(37,37,37,.1) .0625rem .0625rem .125rem .0625rem;
    cursor: pointer;
  `;

